import { OEETrendCarousel } from "../../components/Carousels/OEECarousel/OEECarousel.view";
import { OEESidebarView } from "../../components/OEEGaugesSidebar/OEEGaugesSidebar.view";

export const OEEView = () => {
    return <OEETrendCarousel selectedView={OEESidebarView.OEE} />;
};
